import { HoldNodeData } from 'modules/workflows/types';
import { Duration } from 'modules/workflowNodeEditors/components/formElements/DurationForm';
import { BaseOption } from 'ui/selects';

export type DurationOption = BaseOption & {
  data: Pick<HoldNodeData, 'expireHours' | 'expireDays' | 'expireMinutes'>;
};

export const MAX_DAYS = 30;
export const CUSTOM_DURATION_VALUE = 'custom';

export const durationOptions: DurationOption[] = [
  {
    id: '5minutes',
    label: '5 Minutes',
    value: '5minutes',
    data: { expireHours: 0, expireDays: 0, expireMinutes: 5 },
  },
  {
    id: '15minutes',
    label: '15 Minutes',
    value: '15minutes',
    data: { expireHours: 0, expireDays: 0, expireMinutes: 15 },
  },
  {
    id: '1hour',
    label: '1 Hour',
    value: '1hour',
    data: { expireHours: 1, expireDays: 0, expireMinutes: 0 },
  },
  {
    id: '24Hours',
    label: '24 Hours',
    value: '24Hours',
    data: { expireHours: 24, expireDays: 0, expireMinutes: 0 },
  },
  {
    id: '3Days',
    label: '3 Days',
    value: '3Days',
    data: { expireHours: 0, expireDays: 3, expireMinutes: 0 },
  },
  {
    id: '7Days',
    label: '7 Days',
    value: '7Days',
    data: { expireHours: 0, expireDays: 7, expireMinutes: 0 },
  },
  {
    id: '14Days',
    label: '14 Days',
    value: '14Days',
    data: { expireHours: 0, expireDays: 14, expireMinutes: 0 },
  },
  {
    id: '30Days',
    label: '30 Days',
    value: '30Days',
    data: { expireHours: 0, expireDays: 30, expireMinutes: 0 },
  },
];

export const durationOptionsWithCustom = [
  ...durationOptions,
  {
    id: CUSTOM_DURATION_VALUE,
    label: 'Custom',
    value: CUSTOM_DURATION_VALUE,
    data: { expireHours: 0, expireDays: 0, expireMinutes: 0 },
  },
];

export const durationFormToExpireDataMap: Record<Duration, string> = {
  [Duration.Day]: 'expireDays',
  [Duration.Hour]: 'expireHours',
  [Duration.Minute]: 'expireMinutes',
};
